<form class="mt-4 flex flex-col gap-6" [formGroup]="form">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <div class="font-bold">Test Mode</div>
      <span class="text-xs opacity-90">
        All MOH correspondence will be sent to this email address while Test
        Mode is enabled
      </span>
    </div>

    <div class="flex gap-4">
      <mat-slide-toggle class="flex-1" formControlName="testModeEnabled">
        Enable
      </mat-slide-toggle>
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Test Email Address</mat-label>
        <input matInput formControlName="testEmail" />
      </mat-form-field>
    </div>
  </div>

  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <div class="font-bold">Default Agreement Holder</div>
      <span class="text-xs opacity-90">
        Preselected on every MOH claim and prior approval. It can be changed on
        any individual form.
      </span>
    </div>

    <mat-form-field class="w-1/2 pr-2" subscriptSizing="dynamic">
      <mat-label>Claim As</mat-label>
      <mat-select formControlName="agreementHolderSource">
        @for (source of agreementHolderSources; track source) {
          <mat-option [value]="source">
            {{ agreementHolderSourceLabels[source] }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex flex-col gap-4">
    <div class="font-bold">Practice Provider Details</div>

    <div class="flex gap-4">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Practice Payee Number</mat-label>
        <input
          matInput
          formControlName="payeeNumber"
          maxlength="6"
          [required]="claimsUnderPractice()"
        />
      </mat-form-field>
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Practice Agreement Number</mat-label>
        <input
          matInput
          formControlName="agreementNumber"
          maxlength="6"
          [required]="claimsUnderPractice()"
        />
      </mat-form-field>
    </div>

    <div class="flex gap-4">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Practice Agreement Holder Name</mat-label>
        <input
          matInput
          formControlName="agreementHolderName"
          [placeholder]="practice().name"
        />
      </mat-form-field>
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>District Health Board Area</mat-label>
        <mat-select formControlName="districtArea">
          @for (district of districts; track district) {
            <mat-option [value]="district">{{ district }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="flex flex-col gap-4">
    <div class="font-bold">Form Email Recipients</div>

    <div class="flex gap-4">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>MOH Claim Form Email</mat-label>
        <input matInput formControlName="claimFormEmail" required />
      </mat-form-field>
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>MOH Prior Approval Form Email</mat-label>
        <input matInput formControlName="preApprovalFormEmail" required />
      </mat-form-field>
    </div>

    <mat-form-field class="w-1/2 pr-2" subscriptSizing="dynamic">
      <mat-label>MOH Enrolment Form Email</mat-label>
      <input matInput formControlName="enrolmentFormEmail" />
    </mat-form-field>

    <div class="flex gap-4">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>CC Email</mat-label>
        <input matInput formControlName="ccEmail" />
        <mat-hint>Receive a copy, with your email visible</mat-hint>
      </mat-form-field>
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>BCC Email</mat-label>
        <input matInput formControlName="bccEmail" />
        <mat-hint>Receive a copy, with your email hidden</mat-hint>
      </mat-form-field>
    </div>
  </div>

  <pt-buttons-container>
    <button
      mat-flat-button
      color="primary"
      [disabled]="saveDisabled$ | async"
      (click)="save()"
    >
      Save
    </button>
  </pt-buttons-container>
</form>
